import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmpresaEditPage } from '@/features/painel-administrativo/empresa/page/edit/EmpresaEditPage';
import { StringToIdpkSchema } from '@/std/schema';

const RouteEmpresaSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteEmpresaParams = z.infer<typeof RouteEmpresaSchema>;

export const Route = createFileRoute('/admin/_a/empresa_/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteEmpresaSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <EmpresaEditPage {...params} />;
}
